import { CreationAccesOrder } from './creation-acces-order.entity';

export class CreationPlannedAccesOrder extends CreationAccesOrder {
	demanderValidation!: boolean;
	
	constructor() {
		super();
	}
}